import { INTERNAL_EMAIL_DOMAIN } from '../types/user.constants';

export function isInternalEmail(email: string | null | undefined): boolean {
  return (
    typeof email === 'string' &&
    email.toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN)
  );
}
